import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * 369526: the navbar needs to know whether the signed-in user is a Super Admin so it can stop
 * offering the three Super-Admin-only screens to people who can't open them. Super Admin lives
 * server-side (Entra group), so the API exposes it via /api/User/Me, which returns 200 for
 * everyone. Fail closed: any error means "not a super admin".
 */
@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  private readonly http = inject(HttpClient);

  readonly isSuperAdmin = toSignal(
    this.http.get<{ isSuperAdmin: boolean }>(`${environment.apiBaseUrl}/api/User/Me`).pipe(
      map(r => r.isSuperAdmin === true),
      catchError(() => of(false))
    ),
    { initialValue: false }
  );
}
